<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
const animationDuration = 6000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    weekTourists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    weekTourists: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })
      this.setOptions(this.weekTourists)
    },
    setOptions(weekTourists) {
      var option

      option = {
        grid: {
          // left: "2%",
          // right: "2%",
          // bottom: "0",
          // containLabel: true,
          left: 0,
          right: 15,
          bottom: 25,
          top: 40,
          containLabel: true,
        },
        title: {
          text: '當週出團人數',
          textStyle: {
            fontSize: 18,
            fontWeight: 'bolder',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: {
          type: 'category',
          data: ['一', '二', '三', '四', '五', '六', '日'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '人數',
            data: weekTourists,
            type: 'bar',
            color: ['#FFC107'],
          },
        ],
      }

      if (option && typeof option === 'object') {
        this.chart.setOption(option)
      }

      window.addEventListener('resize', this.chart.resize)
    },
    initChart2_beforeVersion() {
      let vm = this
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        title: {
          text: '當週出團人數',
          x: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: ['一', '二', '三', '四', '五', '六', '日'],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '人數',
            type: 'bar',
            stack: 'vistors',
            barWidth: '60%',
            // data: [79, 52, 200, 334, 390, 330, 220],
            data: vm.weekTourists,
            animationDuration,
          },
          {
            name: 'pageB',
            type: 'bar',
            stack: 'vistors',
            barWidth: '60%',
            data: [],
            animationDuration,
          },
          {
            name: 'pageC',
            type: 'bar',
            stack: 'vistors',
            barWidth: '60%',
            data: [],
            animationDuration,
          },
        ],
      })
    },
  },
}
</script>
